import React from "react";
import "./RolesOffered.css";

const roles = [
  {
    title: "HR Intern",
    img: "/images/hr.jpg",
    overview:
      "An HR Intern supports the HR department in daily operations, recruitment activities, employee coordination, and HR documentation while gaining hands-on experience in human resource management.",
    points: [
      "Assist in end-to-end recruitment (screening resumes, scheduling interviews)",
      "Coordinate with candidates and hiring managers",
      "Maintain employee records and HR databases",
      "Support onboarding and induction processes",
      "Assist in HR documentation and file management",
      "Help prepare offer letters, appointment letters, and reports"
    ]
  },
  {
    title: "Finance Intern",
    img: "/images/finance.jpg",
    overview:
      "A Finance Intern supports the finance team in day-to-day financial operations, reporting, documentation, and analysis while gaining practical exposure to corporate finance and financial services.",
    points: [
      "Assist in preparing financial reports and MIS statements",
      "Support data entry, verification, and reconciliation of financial records",
      "Help track expenses, invoices, and payments",
      "Assist in budgeting and cost analysis activities",
      "Support compliance documentation and audit preparation",
      "Assist in basic analysis of insurance, mutual fund, SIP, and loan products"
    ]
  },
  {
    title: "Sales Intern",
    img: "/images/sales.jpg",
    overview:
      "A Sales Intern supports the sales team in lead generation, customer interaction, sales coordination, and market research while gaining practical exposure to sales processes and customer relationship management.",
    points: [
      "Assist in lead generation and prospect identification",
      "Support sales executives in client follow-ups and coordination",
      "Help prepare sales presentations, proposals, and reports",
      "Maintain customer data and update CRM records",
      "Conduct basic market research and competitor analysis",
      "Support promotional and field marketing activities"
    ]
  },
  {
    title: "Marketing Intern",
    img: "/images/marketing.jpg",
    overview:
      "A Marketing Intern supports the marketing team in planning, executing, and analyzing marketing campaigns while gaining hands-on experience in digital and offline marketing activities.",
    points: [
      "Assist in planning and executing marketing campaigns",
      "Support social media content creation and posting",
      "Help manage digital marketing activities (SEO, ads, email campaigns)",
      "Conduct market research and competitor analysis",
      "Assist in preparing marketing materials, posters, and presentations",
      "Support lead generation and promotional activities"
    ]
  },
  {
    title: "Operations Intern",
    img: "/images/operation.jpg",
    overview:
      "An Operations Intern supports daily business operations, process coordination, documentation, and service execution to ensure smooth and efficient functioning of the organization.",
    points: [
      "Assist in day-to-day operational activities and coordination",
      "Support documentation, data entry, and record maintenance",
      "Help process insurance, mutual fund, SIP, and loan applications",
      "Coordinate with internal teams for service delivery",
      "Track operational workflows and update status reports",
      "Support customer service and query resolution"
    ]
  }
];

export default function RolesOffered() {
  return (
    <section className="roles-section">
      <h2 className="roles-title">Intern Offered</h2>

      <div className="roles-grid">
        {roles.map((role, index) => (
          <div className="role-card" key={index}>
            <img src={role.img} alt={role.title} />

            <h3>{role.title}</h3>

            <p className="role-overview">{role.overview}</p>

            {/* SUMMARY VERSION – NO BULLETS */}
            <p className="role-summary">
              {role.points.join(", ")}.
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
